import { ethers } from "ethers";
import { EVM_CONFIG, type TokenInfo } from "../../config";
import type { StoredJoinSplitNote } from "../../joinsplit/types";
import { privateSpendSource } from "../../joinsplit-v2/privatePools";

/** Swap MAX uses spendable notes from one pool, independent of fee policy. */
export function getSwapInputPrivateBalance(
  notes: readonly StoredJoinSplitNote[],
  token: TokenInfo,
  pendingSpentCommitments: ReadonlySet<string>,
  legacyTokenHash?: bigint,
): string {
  const available = notes.filter(
    (n) =>
      !n.spent &&
      !pendingSpentCommitments.has(n.note.commitment.toLowerCase()) &&
      Number.isSafeInteger(n.note.leafIndex) &&
      n.note.leafIndex >= 0,
  );
  // Flat token hashes also include the pool and tree. The legacy hash map is
  // deliberately empty on these networks, including Doge without private fees.
  const balance = EVM_CONFIG.JOINSPLIT_V2.ENABLED
    ? privateSpendSource(available, token.address).amount
    : legacyTokenHash === undefined
      ? 0n
      : available
          .filter((n) => n.note.tokenHash === legacyTokenHash)
          .reduce((sum, n) => sum + n.note.value, 0n);
  return ethers.formatUnits(balance, token.decimals);
}
